export default __webpack_public_path__ + "static/media/color1.a68722d0.jpg";